<template>
  <div class="status-filter">
    <div class="filter-header">
      <label class="filter-label">{{ $t('filters.status') }}</label>
      <button
        v-if="modelValue.length > 0"
        class="filter-reset-btn"
        :title="$t('action.clear')"
        @click="handleReset"
      >
        {{ $t('action.clear') }}
      </button>
    </div>
    <div class="filter-checkboxes">
      <div v-for="s in statuses" :key="s" class="checkbox-item">
        <input
          :id="`status-${s}`"
          type="checkbox"
          :checked="modelValue.includes(s)"
          class="checkbox-input"
          @change="handleChange(s, $event)"
        />
        <label :for="`status-${s}`" class="checkbox-label">
          {{ $t(`status.${s}`) }}
        </label>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { VoucherReferralStatus } from '@/types/voucherReferral.types'

const statuses: VoucherReferralStatus[] = ['PAID', 'TO_PAY', 'UNPAID', 'EXPORTED']

const props = defineProps<{
  modelValue: VoucherReferralStatus[]
}>()

const emit = defineEmits<{
  'update:modelValue': [statuses: VoucherReferralStatus[]]
}>()

function handleChange(status: VoucherReferralStatus, event: Event) {
  const target = event.target as HTMLInputElement
  const checked = target.checked
  const updated = checked
    ? [...props.modelValue, status]
    : props.modelValue.filter((s) => s !== status)
  emit('update:modelValue', updated)
}

function handleReset() {
  emit('update:modelValue', [])
}
</script>

<style scoped lang="scss">
.status-filter {
  padding: 1rem;
  border-bottom: 1px solid var(--cds-ui-03);
}

.filter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.filter-label {
  font-weight: 600;
  color: var(--cds-text-01);
  margin: 0;
}

.filter-reset-btn {
  background: none;
  border: none;
  color: var(--cds-link-01);
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  padding: 0;
  text-decoration: underline;
  transition: color 0.15s ease;

  &:hover {
    color: var(--cds-link-02);
  }
}

.filter-checkboxes {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.checkbox-input {
  cursor: pointer;
  width: 18px;
  height: 18px;
}

.checkbox-label {
  cursor: pointer;
  font-size: 0.875rem;
  color: var(--cds-text-01);
  margin: 0;
}
</style>
